module.exports = __webpack_public_path__ + "static/fifteen-life-land.3a8ff80f.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/fifteen-life-land.webp
// module id = 926
// module chunks = 3